import { KCommandBase, CommandTriggerAction, CommandEnv } from 'components/cmdk/cmdkTypes'
import { getQuery } from 'components/cmdk/useCommandStore'

export type KAction = KCommandBase & {
  action: CommandTriggerAction
}

export function toAction(this: KAction, { controls: { close } }: CommandEnv) {
  const { action } = this
  return () => close(action(getQuery()))
}
